<div class="toolbar-container">
<mat-toolbar class="p-0 w-full" [ngClass]="tenantClasses">

    <div class="flex flex-row justify-start items-center flex-1 w-full h-full m-0">

        <div class="flex flex-row justify-start items-center flex-1-0-auto">

            @if (!hiddenNavbar && !rightNavbar) {
            <button mat-icon-button class="navbar-toggle-button lg:hidden"
                    (click)="toggleSidebarOpen('main-navbar')">
                <mat-icon>menu</mat-icon>
            </button>
            }

            <!--<div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>-->

            <div class="flex flex-row justify-start items-center">
                <div class="logo hidden md:flex">
                    <img class="logo-icon" [src]="logoUrl">
                </div>
                <trial-message></trial-message>
            </div>

            <div class="px-2 px-mat-16">
                <!--<fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>-->
            </div>

        </div>

        <div class="pr-2 space-x-2 flex flex-row justify-start items-center flex-initial">
            <transcription-usage-alert></transcription-usage-alert>
            @if (canReturnToImpersonate) {
                <button mat-icon-button
                    color="primary"
                    (click)="returnToTenants()"
                    [attr.aria-label]="'toolbar.return_to_tenants' | transloco"
                    [matTooltip]="'toolbar.return_to_tenants' | transloco">
                    <mat-icon>swap_horiz</mat-icon>
                </button>
            }
            <button mat-button
                [matMenuTriggerFor]="helpMenu"
                color="primary"
                aria-label="Ajuda"
                matTooltip="Ajuda">
                <mat-icon>help_outline</mat-icon>
                <span class="px-2"> Ajuda </span>
            </button>
            <mat-menu #helpMenu="matMenu">
                <button mat-menu-item (click)="openKb()">
                    <mat-icon>help_outline</mat-icon>
                    <span>Central de Ajuda</span>
                </button>
                @if (supportChatEnabled) {
                <button mat-menu-item (click)="openChat()">
                  <mat-icon>chat</mat-icon>
                  <span>Chat - Fale com a VSaúde</span>
                </button>
                }
            </mat-menu>

            @if (!isLocked()) {
            <div>
                <button mat-icon-button color="primary" [matMenuTriggerFor]="notificationMenu"
                        (menuOpened)="loadRecentNotifications()">
                    <mat-icon [matBadge]="countUnread + (migrationConsent.pending() ? 1 : 0)"
                              [matBadgeHidden]="countUnread === 0 && !migrationConsent.pending()" matBadgeColor="warn"
                              matBadgePosition="above after" svgIcon="bell">
                    </mat-icon>
                </button>
            </div>
            }

            <mat-menu class="notifications-menu" #notificationMenu="matMenu" [overlapTrigger]="false">
                <div (click)="$event.stopPropagation()">
                    <div class="w-full bg-primary text-white flex items-center">
                        <div class="flex items-center p-4 w-full space-x-4 justify-between">
                            <span class="text-lg">Novas notificações</span>
                            <button mat-icon-button (click)="navigateToNotificationSettings()">
                                <mat-icon>settings</mat-icon>
                            </button>
                        </div>
                    </div>

                    @if (migrationConsent.pending()) {
                        <div *transloco="let t; prefix: 'migration-consent'"
                             class="flex w-full px-4 items-center cursor-pointer hover:bg-gray-50"
                             (click)="openMigrationConsent()">
                            <mat-icon>assignment_late</mat-icon>
                            <div class="flex items-center m-4 w-full">
                                <div class="flex flex-col">
                                    <span class="text-base">{{ t('pendingAlert') }}</span>
                                    <div class="flex items-center">
                                        <span class="text-sm secondary-text">{{ t('pendingAlertSubtitle') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-t border-gray-200"></div>
                    }

                    @if (notifications.length > 0) {
                    <div class="notification-list overflow-auto">
                      @for (notification of notifications; track notification.id) {
                      <div>
                        <div class="flex w-full px-4 items-center cursor-pointer hover:bg-gray-50" (click)="openNotification($event, notification)">
                          <mat-icon>{{notification.icon}}</mat-icon>
                          <div class="flex items-center m-4 w-full">
                            <div class="flex flex-col">
                              <span class="mat-mdc-list-item-title mdc-list-item__primary-text text-base">{{notification.title}}</span>
                              <div class="mat-mdc-list-item-line mdc-list-item__secondary-text flex items-center">
                                <span class="text-sm secondary-text">{{notification.subtitle}}</span>
                              </div>
                            </div>
                          </div>
                          <button color="primary" mat-icon-button (click)="markAsRead($event, notification.id)">
                            <mat-icon>check</mat-icon>
                          </button>
                        </div>
                        <div class="border-t border-gray-200"></div>
                      </div>
                      }
                    </div>
                    }

                    @if (notifications.length === 0 && !migrationConsent.pending()) {
                    <div class="m-8 flex flex-col justify-center items-center">
                        <span>{{l("Pages.Notifications.Recent.Empty.Message")}}</span>
                    </div>
                    }

                    <mat-divider></mat-divider>

                    <div class="m-2 flex flex-row justify-between items-center">
                        <button mat-button color="primary" (click)="showAllNotifications()">
                            {{l("Pages.Notifications.Action.ShowAll.Title")}}
                        </button>
                        @if (notifications.length > 0) {
                        <button mat-button color="primary" (click)="markAllNotificationsAsRead()">
                            <mat-icon class="mat-icon material-icons">check</mat-icon>
                            {{l("Pages.Notifications.Action.MarkAllAsRead.Title")}}
                        </button>
                        }
                    </div>

                </div>
            </mat-menu>

            <button mat-button color="primary" [matMenuTriggerFor]="profileMenu" class="navbar-toolbar-button">
                <div class="flex flex-row justify-center items-center">
                    <span class="username mr-3 user-name-wide">{{username}}</span>
                    <mat-icon class="s-16 user-name-wide">keyboard_arrow_down</mat-icon>
                    <img class="w-8 h-8 border-radius-100 user-avatar-narrow" [src]="avatarUrl">
                </div>
            </button>

            <mat-menu #profileMenu="matMenu" [overlapTrigger]="false">
                <div (click)="$event.stopPropagation()" class="profile-menu-container">
                    <div class="m-4 flex flex-row justify-start items-center">
                        <div class="flex flex-row justify-start items-center">
                            <img class="w-16 h-16 border-radius-100" [src]="avatarUrl">
                            <div class="ml-4">
                                <div class="text-bold">{{this.fullName}}</div>
                                <!--<div class="h5 text-bold secondary-text">20 mins. ago</div>-->
                                @if (!isLocked()) {
                                <div class="mt-2">
                                    @if (showItemProfileInfo) {
                                    <button mat-button color="accent" routerLink="/account/profile"
                                            routerLinkActive="active" (click)="navigateToProfilePage()">{{l("Pages.Landing.Toolbar.Action.Profile.Title")}}</button>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                    </div>
                    @if (!isLocked()) {
                    <div class="toolbar-profile-menu-options-list">
                        <div class="h-12 px-4 flex items-center">{{ 'toolbar.account' | transloco: { tenantId } }}</div>
                        <button mat-menu-item (click)="openLegalDocuments()">{{ 'toolbar.legal_documents' | transloco }}</button>
                        @if (isLegacyVersion && isAdmin) {
                        <button mat-menu-item (click)="openPlansAndSubscriptions()">{{ 'toolbar.plans_and_subscriptions' | transloco }}</button>
                        }
                    </div>
                    }

                    <div class="pl-4 mb-4">
                        <mat-divider></mat-divider>
                    </div>

                    <div class="ml-1 mt-3 mb-1 mr-2 flex flex-row justify-end items-center">
                        <button mat-button color="warn" (click)="logout()">
                            <mat-icon class="mat-icon material-icons">exit_to_app</mat-icon>
                            {{l("Logout")}}
                        </button>
                    </div>

                </div>
            </mat-menu>

            <!--<div class="toolbar-separator"></div>-->

            @if (chatEnabled) {
            <button mat-icon-button class="navbar-toggle-button lg:hidden"
                    (click)="toggleSidebarOpen('chatPanel')">
                <mat-icon class="s-32" svgIcon="chat"></mat-icon>
            </button>
            }

            @if (!hiddenNavbar && rightNavbar) {
            <button mat-icon-button class="navbar-toggle-button lg:hidden"
                    (click)="toggleSidebarOpen('main-navbar')">
                <mat-icon class="">menu</mat-icon>
            </button>
            }

        </div>

    </div>

</mat-toolbar>
</div>
